import { useEffect, useRef } from "react";
import { useLocalParticipant } from "../../../hooks/useLocalParticipant";
import { useRoom } from "../../../hooks/useRoom";
import { isMobile } from "../../../utils/isMobile";

/**
 * ### Handler para visibilidade no mobile
 * Lida com possíveis casos em que o aplicativo fique em segundo plano no mobile, e então para de enviar os tracks caso estiverem habilitados
 */
const VisibilityHandler = () => {
  const { room } = useRoom();
  const { videoOff, audioOff, handleVideo, handleAudio } =
    useLocalParticipant();

  const shouldRestartVideoOnForeground = useRef(false);
  const shouldRestartAudioOnForeground = useRef(false);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (room && isMobile) {
      // Busca pelo dataTrack nos tracks do participante
      const [localDataTrackPublication] = [
        ...Array.from(room.localParticipant.dataTracks.values()),
      ];

      const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
          if (localDataTrackPublication)
            localDataTrackPublication.track.send("background");

          if (!videoOff) {
            shouldRestartVideoOnForeground.current = true;
            handleVideo();
          }
          if (!audioOff) {
            shouldRestartAudioOnForeground.current = true;
            handleAudio();
          }
        } else {
          if (localDataTrackPublication)
            localDataTrackPublication.track.send("foreground");

          if (shouldRestartVideoOnForeground.current) {
            shouldRestartVideoOnForeground.current = false;
            handleVideo();
          }
          if (shouldRestartAudioOnForeground.current) {
            shouldRestartAudioOnForeground.current = false;
            handleAudio();
          }
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };
    }
  }, [room, audioOff, videoOff, handleAudio, handleVideo]);

  return null;
};

export default VisibilityHandler;
